import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './PremiumUnlockedAnimation.css';

interface PremiumUnlockedAnimationProps {
  show: boolean;
  onClose: () => void;
}

const PremiumUnlockedAnimation: React.FC<PremiumUnlockedAnimationProps> = ({ show, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  const benefits = t('premiumUnlocked.benefits', { returnObjects: true }) as { title: string; subtitle: string }[];

  return ReactDOM.createPortal(
    <div className="pu-backdrop" onClick={onClose}>
      <div className="pu-modal" onClick={e => e.stopPropagation()}>
        <div className="pu-badge">
          <span className="pu-badge-dot" />
          {t('premiumUnlocked.badge')}
        </div>
        <div className="pu-icon">
          <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 10V6.5C2.5 3.46 4.96 1 8 1C10.5 1 12.6 2.66 13.3 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
            <rect x="0.8" y="10" width="16.4" height="10.5" rx="2" stroke="currentColor" strokeWidth="1.6"/>
          </svg>
        </div>
        <div className="pu-wolof">{t('premiumUnlocked.wolofGreeting')}</div>
        <div className="pu-name">{t('premiumUnlocked.title')}</div>
        <div className="pu-divider">
          <span className="pu-divider-line" />
          <span className="pu-divider-diamond" />
          <span className="pu-divider-line" />
        </div>
        <div className="pu-benefits">
          {benefits.map((benefit, i) => (
            <div className="pu-benefit" key={i}>
              <div className="pu-benefit-icon">
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div>
                <div className="pu-benefit-title">{benefit.title}</div>
                <div className="pu-benefit-subtitle">{benefit.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
        <button className="pu-button" onClick={onClose}>
          {t('premiumUnlocked.button')}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default PremiumUnlockedAnimation;
